import { useState } from 'react';

import { Select, SelectItem } from '~/components/ui/select';
import { cn } from '~/styles/extended-theme';
import { fromStripeFormat } from '~/utils/currency';

interface Item {
  id: string;
  name: string;
  priceCents: number;
}

export interface PurchaseSelectProps<T extends Item> {
  items: T[];
  onChange: (itemId: string) => void;
  placeholder: string;
}

export function PurchaseSelect<T extends Item>({
  items,
  onChange,
  placeholder,
}: PurchaseSelectProps<T>) {
  const [selectValue, setSelectValue] = useState<string | undefined>(undefined);
  const [selectOpen, setSelectOpen] = useState(false);

  return (
    <Select
      className="h-[unset] bg-transparent p-0 pb-1 text-left text-body2 [&>span]:grow"
      placeholder={placeholder}
      onValueChange={(value) => {
        setSelectValue(value);
        onChange(value);
      }}
      value={selectValue}
      contentPosition="popper"
      open={selectOpen}
      onOpenChange={setSelectOpen}
      iconProps={cn('ml-2 transition-transform duration-200', selectOpen ? 'rotate-180' : '')}
      scrollOnOverflow
    >
      {items.map((item) => (
        <SelectItem className="block" key={item.id} value={item.id.toString()}>
          <div className="flex text-body2">
            <span className="max-w-[200px] break-words">{item.name}</span>
            <span className="ml-auto text-gray-900">{fromStripeFormat(item.priceCents)}</span>
          </div>
        </SelectItem>
      ))}
    </Select>
  );
}
